import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://aqxyruinlvoianxgbsxx.supabase.co';
const SUPABASE_SERVICE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFxeHlydWlubHZvaWFueGdic3h4Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3ODM4MDYxNywiZXhwIjoyMDkzOTU2NjE3fQ.p_BMG4yTdP2BTZgEYiQ3nWKv08ExtKyU29O8WiNehdg';

export const supabaseAdmin = createClient(SUPABASE_URL, SUPABASE_SERVICE_KEY, {
  auth: { autoRefreshToken: false, persistSession: false }
});
